import React from "react";
import { MapPin } from "lucide-react";
import { COMPANY } from "@/lib/api";

export function ServiceArea() {
  return (
    <section className="relative py-24 lg:py-32 border-t border-slate-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl mb-12">
          <div className="text-xs tracking-[0.3em] uppercase font-bold text-primary-brand mb-3">
            Where We Run
          </div>
          <h2 className="font-heading text-4xl md:text-5xl font-black tracking-tight">
            Proudly serving all 50 states.
          </h2>
          <p className="mt-4 text-slate-600">
            Headquartered in Salt Lake City, Utah — running freight coast to coast
            across the entire United States.
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-slate-200 border border-slate-200">
          {COMPANY.coverage.map((c) => (
            <div key={c} className="bg-brand-bg px-6 py-8 flex items-center gap-3 hover:bg-white transition-colors">
              <MapPin className="h-4 w-4 text-primary-brand" />
              <span className="font-heading font-bold uppercase tracking-wide text-sm">{c}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
